import styled, {css} from "styled-components";

export const TabHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  //width: 1000px;
  width: 100%;
`

export const StyledTab = styled.button`
  width: 100%;
  background-color: transparent;
  padding: 0 0.5em;
  border: none;
  border-radius: 5px;
  font-weight: 700;
  cursor: ${(props) => (props.active ? "default" : "pointer")};
  color: var(--color-purple-06);
  ${(props) =>
          props.active &&
          css`
            color: var(--color-purple);
            background-color: var(--color-purple-lighten);
          `}
  cursor: ${(props) => !props.active && props.inactiveStyle};
  height: 2rem;

  &:hover {
    background-color: var(--color-purple-lighten);
    color: var(--color-purple);
  }

`

export const TabsHolder = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 1000px) {
    flex-direction: row;
  }
`

export const inactiveTab = {
    opacity: 0.65,
}

export const Slider = styled.div`
  display: none;
  @media (min-width: 1000px) {
    display: initial;
    width: ${(props) => `${props.width}px`};
    height: 4px;
    background-color: var(--color-purple);
    transition: 0.2s;
    transform: ${(props) => `translateX(${props.width * props.index}px)`};
  }
`